import React from "react";
import { formatMoneda } from "../utils/formatMoneda";
import { formatFechaSegura } from "../services/formatFechaSegura";
import { esFormaPagoHubPagos } from "./transaccionalHubPagos";
import "./Transaccional.css";

const TransaccionalTable = ({ transacciones }) => (
    <div className="table-container">
      <table className="cierre-turno-table transaccional-tabla-resultados">
        <thead>
          <tr>
            <th>Num. Factura</th>
            <th>Placa</th>
            <th>Fecha Inicial</th>
            <th>Fecha Final</th>
            <th>Valor EF</th>
            <th>Valor Datafono</th>
            <th>Hub de Pagos</th>
            <th>Total</th>
            <th>Cod. Empleado</th>
            <th>Cod. Terminal</th>
            <th>Cod. Park</th>
            <th>Id Inicio Turno</th>
          </tr>
        </thead>
        <tbody>
          {transacciones.map((t) => {
            const hub = esFormaPagoHubPagos(t);
            return (
              <tr
                key={t.id}
                className={hub ? "transaccional-fila-hub" : undefined}
                title={hub ? "Hub de pagos (forma de pago 73)" : undefined}
              >
                <td>
                  {hub ? (
                    <>
                      <span className="transaccional-badge-hub" aria-label="Hub de pagos">
                        HUB
                      </span>
                      <span>{t.num_factura}</span>
                    </>
                  ) : (
                    t.num_factura
                  )}
                </td>
                <td>{t.placa}</td>
                <td>{formatFechaSegura(t.fecha_inicial)}</td>
                <td>{formatFechaSegura(t.fecha_final)}</td>
                <td className="valor-monetario">{formatMoneda(t.valor_ef)}</td>
                <td className="valor-monetario">{formatMoneda(t.valor_datafono)}</td>
                <td className="valor-monetario">
                  {hub ? formatMoneda(t.valor_datafono) : "—"}
                </td>
                <td className="valor-monetario">{formatMoneda(t.total)}</td>
                <td>{t.codEmpleado}</td>
                <td>{t.codTerminal}</td>
                <td>{t.codPark}</td>
                <td>{t.idInicioTurno}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );

export default TransaccionalTable;
